var map = {
	"./cert-finance-cpttm-sc.jpg": 436,
	"./cert-fsi-cpttm-sc.jpg": 438,
	"./cert-general-staff-a-cpttm-sc.jpg": 440,
	"./cert-general-staff-cpttm-sc.jpg": 442,
	"./cert-general2024-cpttm-sc.jpg": 370,
	"./cert-senior-manager-cpttm-sc.jpg": 448,
	"./cert-student-cpttm-sc.jpg": 451
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3271;